import angular from 'angular'
import licenseTableDir from './license_table'
import userDeviceTableDir from './user_devices_table'
import userSummaryDir from './user_summary'
import userInfoService from './user_info_service'
import ipToLocationService from './ip_to_location_service'
import UserEvents from './UserEvents.vue'

export default angular
  .module('adminPanel.userDetail', [])
  .factory('userInfo', userInfoService)
  .factory('ipToLocation', ipToLocationService)
  .directive('licenseTable', licenseTableDir)
  .directive('userDeviceTable', userDeviceTableDir)
  .directive('userSummary', userSummaryDir)
  .value(UserEvents.name, UserEvents)
